import { useAppRouter } from '../useAppRouter';
import { type ThemeNames } from '@doxyme/ui/theme';
import { getPublicRuntimeConfig } from '../../libs/init/getPublicRuntimeConfig';

const { paths } = getPublicRuntimeConfig();
const DARK_THEME_PATHS = new Set([paths.call, paths.callHold]);

/**
 * Get theme name based on router pathname.
 * For now: dark for /call, light for all others.
 */
export const useThemeNameByRoute = (): ThemeNames => {
  const { pathname } = useAppRouter();

  return DARK_THEME_PATHS.has(pathname) ? 'dark' : 'light';
};
